import PerfectScrollbar from 'perfect-scrollbar'

let ps = null

document.addEventListener('DOMContentLoaded', () => {
  // Bootstrap Collapse Event: Hamburger Menu
  const winNavbarCollapsible = document.getElementById('winNavbar');
  if (winNavbarCollapsible != null) {  
    winNavbarCollapsible.addEventListener('shown.bs.collapse', () => {
      activateMegaMenuScrollbar();
    });
  }

  // Bootstrap Collapse Event: Hamburger Menu Inner Accordion
  const winNavBarMobileAccordion = document.getElementById('headerAccordion');
  if (winNavBarMobileAccordion != null) {
    winNavBarMobileAccordion.addEventListener('show.bs.collapse', headerAccordionEventListener);
    winNavBarMobileAccordion.addEventListener('hide.bs.collapse', headerAccordionEventListener);
  }

  // activate mega menu scrollbar
  activateMegaMenuScrollbar();
})

// Perfect Scrollbar
const activateMegaMenuScrollbar = () => {
  // if on mobile
  const mobileLogo = document.querySelector('#winNavbar .logo');
  if (mobileLogo != null && window.getComputedStyle(mobileLogo).display !== "none") {
    const container = document.querySelector('#winNavbar .navbar-wrapper');
    if (container == null) return;

    if (ps == null) {
      ps = new PerfectScrollbar(container, {
        suppressScrollX: true,
        wheelPropagation: true,
        scrollingThreshold: 0,
      });
    } else {
      ps.update();
    }
  }
}

const headerAccordionEventListener = (e: Event) => {

  const el = (e.target as HTMLElement).closest('.nav-item')
  e.type === "show.bs.collapse" ? el.classList.add('open') : el.classList.remove('open');

  e.stopPropagation();
}
